/**
 * EL EQUIPO, PARA EL DESPLEGABLE DEL `@`.
 *
 * Nombrar a un compañero (Lissette, 2026-09-12) se escribe en cajas de texto
 * repartidas por toda la aplicación: notas del cliente, comentarios de una
 * nota, notas de la póliza, notas del pago del mes, tareas, tickets, bóveda,
 * reclamos. Todas necesitan la MISMA lista de compañeros, y esa lista ya está
 * cargada una sola vez arriba del todo (`users` en `deskte-full.jsx`).
 *
 * ── POR QUÉ ESTO Y NO PASARLO POR PROPS ────────────────────────────────────
 *
 * Porque el camino hasta esas cajas es largo y no tiene nada que ver con el
 * equipo. Para que la caja de notas de una póliza lo recibiera habría que
 * pasarlo por `PolicyCard` y por todos los sitios que pintan una `PolicyCard`,
 * que son muchos y a los que el equipo les da igual. Es la clase de cambio que
 * ensucia media docena de firmas para una comodidad de la pantalla.
 *
 * ── POR QUÉ NO UN CONTEXTO DE REACT ────────────────────────────────────────
 *
 * Porque en esta aplicación NO HAY NINGUNO: `grep createContext` no encuentra
 * nada. Un almacén de módulo, en cambio, es un patrón que ya existe aquí
 * (`uiPrefsStore.js`), así que esto no añade una forma nueva de hacer las
 * cosas — usa la que ya había.
 *
 * ── LO QUE ESTO NO ES ──────────────────────────────────────────────────────
 *
 * No es la fuente de verdad de nada. Es una copia de solo lectura para pintar
 * un menú. Si llega vacía o desfasada, el menú no sale o sale corto, y
 * `@María Fernanda` tecleado a mano sigue funcionando exactamente igual: quien
 * resuelve la mención es el servidor, con la lista de verdad.
 *
 * Por eso tampoco se guarda en `localStorage`: son nombres del equipo y no
 * tienen por qué quedarse en el disco de nadie.
 */

let equipo = [];
const oyentes = new Set();

/**
 * Publicar el equipo. Se llama una vez desde arriba, cada vez que la lista de
 * usuarios cambia.
 *
 * Se queda SOLO con lo que el menú necesita —id y nombre— y descarta el resto.
 * La lista de usuarios trae correos, teléfonos y NPN; nada de eso pinta aquí, y
 * lo que no se copia no se puede filtrar por accidente.
 */
export function publicarEquipo(usuarios) {
  const limpio = (Array.isArray(usuarios) ? usuarios : [])
    .map((u) => ({ id: u?.id, name: String(u?.name || u?.displayName || '').trim(), email: u?.email || '' }))
    .filter((u) => u.id && u.name);
  // Sin cambios reales no se avisa a nadie: `users` se reasigna en cada
  // refresco y esto se llama desde un efecto.
  const igual = limpio.length === equipo.length
    && limpio.every((u, i) => u.id === equipo[i].id && u.name === equipo[i].name);
  if (igual) return;
  equipo = limpio;
  oyentes.forEach((f) => { try { f(equipo); } catch { /* un oyente roto no tumba a los demás */ } });
}

/** El equipo tal como está ahora. */
export function equipoActual() {
  return equipo;
}

/** Avisar cuando cambie. Devuelve cómo dejar de escuchar. */
export function alCambiarElEquipo(fn) {
  oyentes.add(fn);
  return () => oyentes.delete(fn);
}
